import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './container/App';
import './styles.css';

ReactDOM.render(
  <App />,
  document.querySelector('#root'),
);
